import { WalletService } from "./walletService";

export default WalletService;
